import axios from 'axios'
axios.defaults.withCredentials = true
axios.defaults.baseURL = process.env.VUE_APP_API_URL
export default {
	namespaced: true,
	state: {
		authenticated: null,
		user: null,

		delete_image: null,

		message: '',
		loading: false,
	},
	mutations: {
		setAuthenticated(state, value) {
			state.authenticated = value
		},
		setUser(state, value) {
			state.user = value
			// Con null (sesion vencida o no iniciada) no hay id que guardar: antes tiraba un
			// TypeError en cada carga sin sesion.
			if (state.user) {
				window.localStorage.setItem('user_id', state.user.id)
			}
		},
		setLoading(state, value) {
			state.loading = value
		},
		setMessage(state, value) {
			state.message = value
		},
		setDeleteImage(state, value) {
			state.delete_image = value
		},
	},
	actions: {
		/**
		 * Arranque de la sesion: /sanctum/csrf-cookie y despues /api/user.
		 *
		 * No devuelve la promesa a proposito: App.vue encadena un .then que hoy corre ANTES de que
		 * esto resuelva (con authenticated todavia en null) y el flujo de rutas del arranque esta
		 * armado alrededor de eso. Lo que cambia (15/9/2026) es como se trata una FALLA: ver
		 * _me_intento.
		 */
		me({commit, dispatch}) {
			commit('setMessage', 'Iniciando')
			commit('setLoading', true)
			dispatch('_me_intento', 1)
		},
		/**
		 * Un intento de arranque, con reintento ante fallas que NO son de sesion.
		 *
		 * Antes, CUALQUIER fallo de /api/user dejaba al usuario como no autenticado y lo mandaba a
		 * la pantalla de login: tambien un 500 por "Too many connections" del MySQL compartido de
		 * Hostinger (pasa todos los dias, en ventanas de pocos minutos) o un corte de red de un
		 * segundo. Eso es lo que se reportaba como "pierdo la conexion con el servidor": la sesion
		 * seguia valida, pero la SPA la daba por perdida y el usuario volvia a loguearse, sumando
		 * mas requests justo cuando el servidor estaba saturado. Y si lo que fallaba era el
		 * csrf-cookie, nadie lo atrapaba: el logo de carga quedaba girando para siempre.
		 *
		 * Ahora solo un 401/419 (sesion vencida de verdad) manda al login de una. Todo lo demas
		 * —sin respuesta, 5xx, 429, 503— se reintenta con espera creciente (1, 2 y 4 segundos)
		 * avisando en pantalla, y recien si se agotan los intentos se cae al login como antes,
		 * para no dejar al usuario colgado.
		 */
		_me_intento({commit, dispatch}, intento) {
			const MAX_INTENTOS = 4
			axios.get('/sanctum/csrf-cookie')
			.then(() => {
				return axios.get('/api/user')
			})
			.then(res => {
				commit('setMessage', '')
				commit('setLoading', false)
				commit('setAuthenticated', true)
				commit('setUser', res.data.user)
			})
			.catch(err => {
				let status = err && err.response ? err.response.status : null
				let sesion_vencida = status == 401 || status == 419
				if (!sesion_vencida && intento < MAX_INTENTOS) {
					let espera_ms = 1000 * Math.pow(2, intento - 1)
					console.log('auth/me: fallo sin ser de sesion (status ' + status + '), reintento ' + intento + ' en ' + espera_ms + ' ms')
					commit('setMessage', 'Reconectando con el servidor (' + intento + ' de ' + (MAX_INTENTOS - 1) + ')')
					setTimeout(() => {
						dispatch('_me_intento', intento + 1)
					}, espera_ms)
					return
				}
				commit('setMessage', '')
				commit('setLoading', false)
				commit('setAuthenticated', false)
				commit('setUser', null)
			})
		},
		logout({ commit }) {
			commit('setMessage', 'Cerrando Sesion')
			commit('setLoading', true)
			return axios.post('/logout')
            .then(() => {
				commit('setMessage', '')
                commit('setLoading', false)
                commit('setAuthenticated', false)
                commit('setUser', null)
            })
            .catch(err => {
                commit('setLoading', false)
				commit('setMessage', '')
                console.log(err)
            })
		},
		deleteImage({ commit, state }) {
			return axios.delete(`/api/delete-current-image/user/${state.user.id}`)
			.then((res) => {
				commit('setUser', res.data.model)
			})
			.catch((err) => {
				console.log(err)
			})
		},
	},
}
